import { render, staticRenderFns } from "./image-slider.vue?vue&type=template&id=26a1c1d6&"
import script from "./image-slider.vue?vue&type=script&lang=js&"
export * from "./image-slider.vue?vue&type=script&lang=js&"
import style0 from "./image-slider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports